// extracted by mini-css-extract-plugin
export default {"bg_gray":"file_dropzone_bg_gray__Hx8to","custom_dropzone":"file_dropzone_custom_dropzone__6ia69","card_progressing":"file_dropzone_card_progressing__GutOv"};